











































import { defineComponent, ref, computed, watch } from "@vue/composition-api";
import useUserSettings from "@/store/useUserSettings";
import UserSettingsViewModel from "@/models/UserSettingsViewModel";

export default defineComponent({
    name: "EditGasDialog",
    components: {
        ConfirmDialog: () => import("../Dialogs/ConfirmDialog.vue"),
    },
    props: {
        value: { type: Boolean, default: false }, // v-model for dialog
    },
    setup(props, context) {
        const { getUserSettings, updateUserSettings } = useUserSettings();

        // Keep a full reactive shape from the start (Vue 2 reactivity)
        const model = ref<UserSettingsViewModel>({
            email: "",
            digitalOutputNickname: "Digital Output",
            gasThreshold: 600,
            bilgeThreshold: 1,
            timezone: "Europe/Copenhagen",
            insertedDate: "",
            modifiedDate: ""
        });

        const showSuccess = ref(false);
        const ready = ref(false);

        // Mapping: 1=Low(1400) 2=Medium(1000) 3=High(600)
        const ppmFromLevel = (lvl: number) => (lvl === 1 ? 1400 : lvl === 2 ? 1000 : 600);
        const levelFromPpm = (ppm?: number) => {
            const n = Number(ppm);
            if (!isFinite(n)) return 3;
            if (n <= 600) return 3;
            if (n <= 1000) return 2;
            return 1;
        };

        const sensitivityLevel = computed<number>({
            get: () => levelFromPpm(model.value.gasThreshold),
            set: (lvl) => { model.value.gasThreshold = ppmFromLevel(lvl); }
        });

        async function load() {
            ready.value = false;
            try {
                const val = await getUserSettings();
                // Replace the whole object (like in Profile) to ensure reactivity
                model.value = {
                    ...model.value,
                    ...val,
                    gasThreshold: Number(val?.gasThreshold ?? 600)
                };
            } finally {
                ready.value = true;
            }
        }

        // Load latest when dialog is opened (Profile-style timing)
        watch(() => props.value, (open) => { if (open) load(); }, { immediate: true });

        const initSave = async () => {
            if (model.value.gasThreshold == null) model.value.gasThreshold = 600;
            await updateUserSettings(model.value);
            showSuccess.value = true;
            close();
            context.emit("OnSaveGasThreshold", { ...model.value });
        };

        const close = () => {
            context.emit("input", false);
            context.emit("OnCancel");
        };

        const successOk = () => (showSuccess.value = false);

        return {
            model,
            showSuccess,
            ready,
            sensitivityLevel,
            initSave,
            close,
            successOk
        };
    }
});
